module.exports = __webpack_public_path__ + "img/cover2.069712e1.png";